import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useParams } from 'react-router';
import { updateMenuSelected } from 'redux/actions/menu';
import { useDispatch, useSelector } from 'react-redux'
import Loader from "react-loader-spinner";
// ** import gallery
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/scss/image-gallery.scss";
import { IMAGE_BASE_URL, OLD_API_URL } from 'utils/constants';

export default function ListImage() {
    const { id } = useParams()
    const dispatch = useDispatch()
    const [listImage, setListImage] = useState([])
    const [loaded, setLoaded] = useState()
    const standardImage = (listImageArr) => {
        let imgArr = []
        listImageArr.map((item, index) => {
            const tempImg = {
                original: `${IMAGE_BASE_URL}/${item.url}`,
                thumbnail: `${IMAGE_BASE_URL}/${item.url}`,
                description: item.name
            }
            imgArr.push(tempImg)
        })
        return imgArr
    }
    const standardAlbum = (dataMenu) => {
        let menu = {
          id: 1,
          title: 'Media',
          type: "INCLUDE",
          path: '/media',
          children: [
          ]
        }
        
        
          dataMenu.map((item, index) => {
            let menuItem = {
              id: item.id,
              
              type: 'CUSTOM_MEDIA',
              title: item.name,
              path: `/list/image/${item.id}`
            }
            menu.children.push(menuItem)
          }
          )
        
        
        return menu
      }
      
    useEffect(() => {
        // set loading to wait get data
        setLoaded(false)
        axios.get(`${OLD_API_URL}/album?unit=Home`).then(resp => {
            const album = standardAlbum(resp.data)
            
            axios.get(`${OLD_API_URL}/album/${id}`).then(response => {
                const temp = {
                    id: response.data.id,
                    type: 'CUSTOM_MEDIA',
                    title: response.data.name,
                    path: `/list/image/${response.data.id}`
                }
                dispatch(updateMenuSelected(album, temp,[]))
                
                axios.get(`${OLD_API_URL}/image/album/${id}`).then(res => {
                    setListImage(standardImage(res.data.rows))
                    setLoaded(true)
                }).catch(error => {
                    console.error("Lỗi gọi API!", error)
                })
            }).catch(error => {
                dispatch(updateMenuSelected(album, {},[]))
                console.error("Lỗi gọi API!", error)
            })
        }).catch(error => {
            console.error("Lỗi gọi API!", error)
        })

    }, [id])
    if (id === undefined) {
        return <div>None of image</div>
    }
    return (
        !loaded ? <Loader type="ThreeDots" color="var(--primary-color)" height="100" width="100" /> :
            <div>
                <ImageGallery
                    items={listImage}
                    lazyLoad={true}
                />
            </div>
    )
}
